import {
	NOTES_FOR_PATIENT_ACTION_TYPES,
	NotesForPatientActions,
	NotesForPatientState,
} from '../../../../types/noteForPatient'

const initialState: NotesForPatientState = {
	notes: [],
}

export default (
	state = initialState,
	action: NotesForPatientActions
): NotesForPatientState => {
	switch (action.type) {
		case NOTES_FOR_PATIENT_ACTION_TYPES.NOTES_FOR_PATIENT_SET_DATA: {
			return {
				notes: action.payload,
			}
		}

		default: {
			return state
		}
	}
}
